import { Uuid } from "@/domains/global/identifiers";
import { UuidNamespace } from "@/modules/uuid/constants";
import { combineUuidsUsingNamespace } from "@/modules/uuid/sync-models/combineUuidsUsingNamespace";
import { v5 as uuidv5 } from "uuid";

export const resolveLocalAudioRecordingBlobId = ({
  associatedAudioRecordingId,
  blobIndex,
}: {
  associatedAudioRecordingId: Uuid;
  blobIndex: number;
}): Uuid => {
  const blobNamespace = `LOCAL_AUDIO_RECORDING_BLOB::${blobIndex}`;

  const namespace = uuidv5(blobNamespace, UuidNamespace.LocalAudioRecordingNamespace);

  return combineUuidsUsingNamespace({
    namespace,
    uuids: [associatedAudioRecordingId],
  });
};

export const resolveLocalAudioRecordingTranscriptTurnId = ({
  associatedAudioRecordingId,
  transcriptTurnIndex,
}: {
  associatedAudioRecordingId: Uuid;
  transcriptTurnIndex: number;
}): Uuid => {
  const turnNamespace = `LOCAL_AUDIO_RECORDING_TRANSCRIPT_TURN::${transcriptTurnIndex}`;

  const namespace = uuidv5(turnNamespace, UuidNamespace.LocalAudioRecordingNamespace);

  return combineUuidsUsingNamespace({
    namespace,
    uuids: [associatedAudioRecordingId],
  });
};

export const resolveAudioRecordingCapturedAudioUuid = ({
  associatedAudioRecordingId,
}: {
  associatedAudioRecordingId: Uuid;
}): Uuid => {
  const upperCasedAssociatedAudioRecordingId = associatedAudioRecordingId.toUpperCase();
  const capturedAudioNamespace = `AUDIO_RECORDING_CAPTURED_AUDIO::${upperCasedAssociatedAudioRecordingId}`;

  const namespace = uuidv5(capturedAudioNamespace, UuidNamespace.LocalAudioRecordingNamespace);

  return combineUuidsUsingNamespace({
    namespace,
    uuids: [associatedAudioRecordingId],
  });
};
